import { requestInterceptor } from "common-frontend-components";
import axios from "axios";

const pulseAxiosInstance = axios.create({
    baseURL: "/pulse-api",
});
const adminAxiosInstance = axios.create({
    baseURL: "/api/",
});
pulseAxiosInstance.interceptors.request.use(requestInterceptor);
adminAxiosInstance.interceptors.request.use(requestInterceptor);

export { pulseAxiosInstance, adminAxiosInstance };
